import React, { useEffect, useState, useCallback } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import {
  listFranchises,
} from "../../Redux/Actions/franchiseAction";
import { columnsFranchise } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast"; // Optional, if you want to show errors

const ListFranchise = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });
  const [tempSearch, setTempSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const dispatch = useDispatch();

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        search: searchQuery,  
      };
      dispatch(listFranchises(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh franchise list"); 
        }
      });
    },
    [dispatch, searchQuery]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  const franchises = useSelector((state) => state.franchises || {});

  useEffect(() => {
    if (franchises?.total) {
      setPagination((prevData) => ({
        ...prevData,
        total: franchises.total,
      }));
    }
  }, [franchises]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const filterHandler = () => {
    setSearchQuery(tempSearch);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleStatusChange = async (record, action) => {
    if (action === "active" || action === "inactive") {
      const payload = {
        id: record._id,
        status: action,
      };
      // await dispatch(updateFranchise(payload));
      // Add dispatch update logic when ready
    }
    fetchDetails(pagination.current, pagination.pageSize);
  };

  return (
    <TableComponent
      h3heading="Franchise List"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsFranchise(handleStatusChange)}
      buttonhead2="Add Franchise"
      navigateTo2="/franchise/add"
      dataSource={
        Array.isArray(franchises?.data) ? franchises.data : []
      }
      setState={setTempSearch}            
      filterFunction={filterHandler}        
    />
  );
};

export default ListFranchise;
